import Model, { attr, hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { ComparisonSet } from 'frontend-utils/utils/constants/benchmark-insight';
import type { BeniMetaComparisonSet } from 'lumen/models';
import type { KpiCategory } from 'lumen/utils/constants/benchmark-insight/beni-constant-values';

export default class BeniMeta extends Model {
  [Type] = 'benchmark-insight/meta' as const;

  // Array of BeniMetaComparisonSet model instances.

  @hasMany('benchmark-insight/meta-comparison-set', {
    async: false,
    inverse: null,
  })
  declare comparisonSets: BeniMetaComparisonSet[];

  @attr declare allSegments: KpiCategory[];
  @attr('string') declare extractDate: string;
  // Lists of the segments whose data are included in the response
  // Ordered by hierarcy, the topmost segment first then it's children if any
  @attr declare requestedSegments: KpiCategory[];
  @attr('string') declare requestedStayDateEnd: string;
  @attr('string') declare requestedStayDateStart: string;

  getMetaForComparisonSet(
    comparisonSet: ComparisonSet,
  ): BeniMetaComparisonSet | null {
    return (
      this.comparisonSets.find(
        (set) => set.comparisonSetType === comparisonSet,
      ) ?? null
    );
  }
}
